<template>
  <div class="page-container">
    <el-row :gutter="20">
      <el-col :span="24">
        <!-- 展会路线说明卡片 -->
        <div class="page-card">
          <!-- 页头 -->
          <div class="page-card__header">
            <el-row>
              <el-col :span="4">
                展会路线说明
              </el-col>
              <el-col :span="20" style="text-align: right">
                <el-button round size="small" @click="updateContent">修改</el-button>
              </el-col>
            </el-row>
          </div>

          <!-- 内容展示 -->
          <div class="page-card__body" v-if="updateShow" style="width: 800px; margin: 0 auto">
            <div v-html="arrange"></div>
          </div>

          <!-- 表单编辑 -->
          <div class="page-card__body" v-else>
            <el-form>
              <div style="text-align: left; padding: 20px 0">说明内容：</div>
              <vue-html5-editor :content="arrange" :height="300" v-model="arrange" :show-module-name="showModuleName"
                                @change="updateData" ref="editor"></vue-html5-editor>
              <div style="padding: 20px 0">
                <el-button type="primary" round @click="submitClick">确认修改</el-button>
                <el-button type="danger" round @click="updateContent">取消修改</el-button>
              </div>
            </el-form>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import api from '../../utils/api'
import {VueEditor} from "vue2-editor";

export default {
  name: "eventRoute",
  data() {
    return {
      showModuleName: true,
      updateShow: true,
      arrange: '',
      newimgUrl: 'https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/news/',
      config_id: localStorage.getItem('config_id')
    }
  },
  mounted() {
    // 获取展会路线信息
    this.getInfo();
  },
  methods: {
    // 获取展会路线信息
    getInfo() {
      let url = this.baseUrl + '/admin/config/';
      api.fetchData(url).then((res) => {
        this.arrange = res[0].arrange;
      })
    },

    // 提交修改展会路线
    submitClick() {
      let url = this.baseUrl + '/admin/config/' + this.config_id + '/';
      api.patchData(url, {
        arrange: this.arrange
      }).then((res) => {
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.updateContent();
      })
    },

    // 更新富文本编辑器内容
    updateData: function (data) {
      this.arrange = data
    },

    // 富文本编辑器上传图片回调函数
    handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      let url = this.baseUrl + '/admin/uploadfile/news/'
      const formData = new FormData();
      formData.append("file", file);
      api.postData(url, formData).then((res) => {
        Editor.insertEmbed(cursorLocation, "image", this.newimgUrl + res.filename);
        resetUploader();
      })
    },

    // 切换编辑/展示状态
    updateContent() {
      this.updateShow = this.updateShow === true ? false : true
    },
  },
  components: {
    VueEditor
  }
}
</script>

<style scoped>
  ::v-deep img {
    width: 100% !important;
    height: 100% !important;
  }

  ::v-deep .vue-html5-editor>.content {
    max-height: 600px;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/eventRoute.vue